module.exports = __webpack_public_path__ + "img/88.a68d2585.jpg";